import Editor from '@/components/editor';
export default {
  name: "record",
  components: {
    Editor: Editor
  },
  props: {
    str: {
      default: function _default() {
        return undefined;
      }
    },
    title: {
      default: function _default() {
        return undefined;
      }
    }
  },
  data: function data() {
    return {
      rules: {
        str: [{
          required: true,
          message: "\u8BF7\u8F93\u5165".concat(this.title),
          trigger: 'change'
        }]
      },
      form: {
        str: this.str
      }
    };
  },
  methods: {
    submit: function submit() {
      this.$emit('submit', this.form.str);
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    change: function change(val) {
      this.form.str = val;
    }
  }
};